module.exports = __webpack_public_path__ + "img/snake.f77f2d3f.png";